var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGithubLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 70,
    viewBox: "0 0 73 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    fillRule: "evenodd",
    d: "M36.425 0C16.53 0 .398 16.066.398 35.887c0 15.855 10.323 29.304 24.64 34.05 1.803.33 2.46-.778 2.46-1.73 0-.853-.031-3.108-.049-6.102-10.022 2.167-12.136-4.812-12.136-4.812-1.64-4.146-4.001-5.25-4.001-5.25-3.272-2.224.247-2.18.247-2.18 3.617.253 5.519 3.699 5.519 3.699 3.214 5.483 8.433 3.899 10.486 2.98.327-2.317 1.259-3.9 2.287-4.796-8-.905-16.412-3.985-16.412-17.736 0-3.917 1.405-7.122 3.71-9.63-.372-.907-1.608-4.557.353-9.497 0 0 3.024-.964 9.907 3.68 2.873-.798 5.957-1.195 9.02-1.21 3.061.015 6.142.412 9.02 1.21 6.879-4.644 9.898-3.68 9.898-3.68 1.966 4.94.73 8.59.36 9.498 2.31 2.507 3.703 5.712 3.703 9.629 0 13.786-8.425 16.82-16.45 17.708 1.292 1.108 2.445 3.297 2.445 6.644 0 4.798-.045 8.669-.045 9.845 0 .96.65 2.077 2.478 1.727 14.306-4.756 24.62-18.197 24.62-34.047C72.457 16.067 56.323 0 36.424 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubLogo);
export default __webpack_public_path__ + "static/media/github-logo.a13e0615.svg";
export { ForwardRef as ReactComponent };